import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IDealerByLocation, IResponseModel } from '@agenda-customer-ui/shared';
import { API, environment } from '@core/envs';
import { GetCountryService } from '@core/services';

@Injectable({
  providedIn: 'root',
})
export class DealerService {
  readonly #getCountryService = inject(GetCountryService);
  dealer!: IDealerByLocation;

  constructor(private http: HttpClient) {}

  async getDealerByIdCode(idCode: number): Promise<IDealerByLocation> {
    const url = `${environment.getRoute(API.dealer)}/dealers/${idCode}?country=${this.#getCountryService.getCountry()}`;

    try {
      const response = await this.http.get<IResponseModel<IDealerByLocation>>(url).toPromise();

      if (response && response['response']) {
        this.dealer = response['response'];

        return this.dealer;
      }

      throw new Error('Response or response.response is undefined.');
    } catch (error) {
      console.error("Error fetching dealer data:", error);
      throw error;
    }
  }

}
